import { useEffect, useRef } from 'react';

const useClickOutside = (callback, ignoreRefs = []) => {
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      const target = e.target;

      if (ref.current && ref.current.contains(target)) return;

      const clickedInsideIgnored = ignoreRefs.some(
        (ignoreRef) => ignoreRef?.current && ignoreRef.current.contains(target),
      );

      if (clickedInsideIgnored) return;

      callback();
    };

    document.addEventListener('mousedown', handleClick);

    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [callback, ignoreRefs]);

  return ref;
};

export default useClickOutside;
